import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-input-label-error-wrapper',
  templateUrl: './input-label-error-wrapper.component.html',
  styleUrls: ['./input-label-error-wrapper.component.scss']
})
export class InputLabelErrorWrapperComponent implements OnInit {
  @Input() labelKey: string;
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() placeholder = '';
  @Input() inputType = 'text';
  @Input() errors: [object] = [{ required: 'ERRORS.REQUIRED' }];
  @Input() tabulatorIndex: number;
  @Input() minValue: number;

  constructor() {}

  ngOnInit() {}
}
